import Vue from 'vue'
import LazyLoad from 'vanilla-lazyload'
import { $$ } from '../_utils'

// todo - add lazy loading

Vue.component('vue-products-list', {
  template: '#vue-products-list-template',
  props: ['products', 'lazyLoading'],
})

const productsList = $$('#vue-products-list-wrapper')
window.addEventListener('DOMContentLoaded', () => {
  if (!productsList) return
  productsList.forEach(element => {
    new Vue({
      el: element,
    })
  })
})
